export { ImageMapper } from './ImageMapperContainer';
